module.exports = __webpack_public_path__ + "img/1564943843.d42b6446.jpg";